import React from 'react';

import DropdownSelections from 'app/collections/dropdown_selections';
import Webhooks from 'app/collections/webhooks';
import Webhook from 'app/models/webhook';
import ApiModeSelection from 'app/models/api_mode_selection';

import Base from 'app/views/base';

import BackboneView from 'app/components/backbone_view';
import PageHeader from 'app/components/page_header_react';
import CardList from 'app/components/card_list';
import PopupCreateFormView, { FormField } from 'app/components/popup_create_form';
import ListItemView from './list_item_view';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'webhooks',

  initialize() {
    this.prodApiMode = new ApiModeSelection({ mode: 'production' });
    this.testApiMode = new ApiModeSelection({ mode: 'test' });

    this.prodCollection = new Webhooks([], { apiModeSelection: this.prodApiMode });
    this.testCollection = new Webhooks([], { apiModeSelection: this.testApiMode });

    this.addReactComponent(
      'header',
      <PageHeader
        name="Webhooks"
        links={[
          { name: 'Docs', href: '/docs/api#webhooks' },
          { name: 'Guide', href: '/webhooks-guide' },
        ]}
      >
        <BackboneView
          View={PopupCreateFormView}
          viewProps={() => ({
            title: 'Add Webhook',
            objectName: 'Webhook',
            ModelClass: Webhook,
            dropdownSelections: new DropdownSelections([
              new ApiModeSelection({}),
            ]),
            formFields: [
              new FormField({ label: 'Webhook URL', paramKey: 'url', placeholder: 'https://example.com/easypost-webhook' }),
            ],
            onCreate: this.fetchCollections,
          })}
          wrapperTag="span"
        />
      </PageHeader>,
    );
    this.addSubview('prodWebhookList', '#prod_webhook_list', new CardList({
      title: 'Production Webhooks',
      ListItemView,
      collection: this.prodCollection,
    }));
    this.addSubview('testWebhookList', '#test_webhook_list', new CardList({
      title: 'Test Webhooks',
      ListItemView,
      collection: this.testCollection,
    }));
  },

  fetchCollections() {
    this.prodCollection.fetch({ reset: true });
    this.testCollection.fetch({ reset: true });
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/webhooks_and_events/webhooks/index.jsx